import 'react-select/dist/react-select.css'
import { h } from 'preact'
import R from 'ramda'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Select from 'react-select'
import arrowImg from '../images/arrow-down.png'

import { CategoryType } from '../reducers'

export const SelectBox = styled(Select)`
  &.is-focused .Select-control {
    border-color: #55C2E6 !important;
  }
  .Select-control {
    border: 1px solid #DCE4E7;
    border-radius: 3px;
    font-size: 16px;
    color: #1F313A;
    box-sizing: border-box;
    width: 100%;
    &:hover {
      box-shadow: none
    }
  }
  .Select-arrow-zone {
    width: 36px;
    padding-right: 5px;
  }
  .Select-arrow {
    background: #fff url(${arrowImg}) no-repeat center;
    background-size: 100%;
    border: 0;
    width: 10px;
    height: 5px;
    vertical-align: middle;
  }
  &.is-open .Select-arrow {
    top: 0;
  }
  &.Select--single > .Select-control .Select-value,
  .Select-placeholder {
    padding: 0 16px;
    line-height: 45px
  }
  .Select-placeholder {
    color: #DCE4E7;
    padding-top: 2px
  }
  &.Select--single.has-value > .Select-control .Select-value .Select-value-label {
    color: #1F313A;
    vertical-align: middle;
  }
  .Select-input {
    padding: 0 16px;
    height: auto;
    margin: 0;
  }
  .Select-input input {
    padding: 15px 0 16px;
  }
  .Select-menu-outer {
    border-radius: 2px;
    border: 0;
    box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.10);
    margin-top: 10px;
    font-size: 16px;
  }
  .Select-option {
    color: #3A3E3E;
    padding: 16px;
  }
  .Select-option:last-child {
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
  }
  .Select-option.is-focused {
    background: #F6F8F9;
    color: #3A3E3E;
  }
  .Select-option.is-selected {
    background: #DCE4E7;
    color: #3A3E3E;
  }
  .Select-clear {
    vertical-align: middle;
    margin-top: -3px;
  }
`

const defaultFilteringOption = {
  id: '',
  name: 'All departments'
}

export const CategorySelect = ({ categories, onChange, value, className }) => (
  <SelectBox
    className={className}
    options={
      R.concat([defaultFilteringOption], categories)
    }
    labelKey="name"
    valueKey="id"
    resetValue={defaultFilteringOption}
    onChange={(opt) => {
      const { id } = opt
      onChange(id || null)
    }}
    value={value || ''}
  />
)

CategorySelect.propTypes = {
  categories: PropTypes.arrayOf(CategoryType).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  className: PropTypes.string
}

CategorySelect.defaultProps = {
  className: undefined
}

export default styled(CategorySelect)``



// WEBPACK FOOTER //
// ./src/components/CategorySelectBox.js